import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_COMBO_NO_COVER_IMAGE_EXPERIMENT = defineFcm('psf_combo_no_cover_image_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Combo (promote_or_share) page',
		description:
			'Kill switch for psf_combo_no_cover_image_experiment, the experiment that hides the placeholder image (element and reserved space) for petitions with no displayable cover image on the combo page. Defaults to disabled, which resolves every session to control at runtime without a deploy.',
		import: false,
		template: { enabled: true },
	});
